'use client'

import { Skeleton } from '@macarongfactory/web-ui'

const Loading = () => (
  <div className='min-h-dvh bg-background-surface-default'>
    <div className='h-[48px]' />
    <div className='mx-auto w-full max-w-[640px]'>
      <Skeleton pattern='card' />
    </div>
  </div>
)

export default Loading
